import React from "react";
import HasNotifications from "core/HasNotifications";

/* -------------------------------------------------------------------------- */
/*                              INDIVIDUAL PATHS                              */
/* -------------------------------------------------------------------------- */

export const homePath = {
    url: "/",
    alt: "Noun Project home"
};

export const eduPath = "/for-edu/";

export const eduApplyPath = "/for-edu/apply/";

export const teamPath = "/team/";

export const proTeamSignupPath = "/accounts/signup/team/";

export const apiGetStartedPath = "/developers/apps/";

export const contactCustomerSupportLink = "mailto:info@thenounproject.com";

export const customerSupportLink = {
    name: "Customer Support",
    href: "https://thenounproject.zendesk.com/",
    external: true
};

export const PHOTO_PATH = "/photos/";

export const photosLandingPath = "/photos/";

export const lingoMarketingPagePath = "/lingo/";

export const iconsSearchPath = "/search/";

export const iconsCollectionSearchPath = "/search/collection/";

export const accountUpgradePath = "/accounts/pricing/";

export const apiMarketingPagePath = "/developers/";

export const appsAndPluginsPath = "/apps/";

export const proSignupPath = "/accounts/signup/pro/";

export const aboutPath = "/about/";

export const legalPath = "/legal/";

export const CAREERS_PATH = "/jobs/";

export const termPath = "/term/";

export const FOR_MAC_PATH = "/for-mac/";

export const FOR_ADOBE_PATH = "/for-adobe/";

export const FOR_GOOGLE_PATH = "/for-google/";

export const FOR_OFFICE_PATH = "/for-office/";

export const prepaidBalancePath = ({ username }) =>
    `/${username}/settings/prepaid-balance/`;

// /upload/ banner link:
export const UPLOADS_SUBMISSION_POLICY =
    "https://medium.com/@lindsaystuart12/c4970c98b050";

// Photos Related Routes
export const PRICING = "/pricing/";
export const SEARCH = `/search/photos/`;
export const BECOME_PHOTOGRAPHER_LANDING_PAGE = "/call-to-photographers/";
// :purchaseType should be lowercase
export const PHOTO_CHECKOUT = "/checkout/photo/:purchaseType/:photoId";
export const PHOTO_DETAIL = "/photo/:photoSlugWithId/";
export const BROWSE_BY_TAG = "/browse/term/photos/:tag/";
// BROWSE_BY_SHOOT_ID :shootInfo consist of {shoot-title}-{shoot-id}
export const BROWSE_BY_SHOOT_ID = "/browse/photo-shoot/:shootInfo/";
export const BROWSE_BY_CREATOR_USERNAME = "/browse/creator/:username/photos/";
export const BROWSE_SIMILAR_BY_PHOTO_ID = "/browse/similar/photos/:photoId/";
// BROWSE_BY_CAMPAIGN :shootInfo consist of {campaign-title}-{campaign-id}
export const BROWSE_BY_CAMPAIGN = "/browse/campaign/:campaignDetail/";

// Icons (2020) Related Routes
export const ICON_LANDING_PAGE = "/icons/";
export const ICON_DETAIL_PAGE = "/private/icon/:slugWithId/";
export const ICON_CHECKOUT = "/private/checkout/icon/:checkoutType/:iconId/";
export const BROWSE_ICONS_SIMILAR =
    "/private/browse/icons/similar/:slugWithId/";

export const SEARCH_CONTENT = "/private/search/:searchType/";
export const SEARCH_ICONS = SEARCH_CONTENT.replace(":searchType", "icons");
export const SEARCH_ICON_COLLECTIONS = SEARCH_CONTENT.replace(
    ":searchType",
    "icon-collections"
);

export const ICON_COLLECTION_SEARCH = "/private/icon/collection/search/:q";
export const CREATOR_COLLECTION_SEARCH =
    "/private/icons/creator/collection/search";
/* -------------------------------------------------------------------------- */
/*                    Subscription LP & Checkout Flows                        */
/* -------------------------------------------------------------------------- */

// NounPro
export const NOUN_PRO_LANDING_PAGE =
    "/pricing/icon-subscription/nounpro-individual/";
export const NOUN_PRO_CHECKOUT =
    "/checkout/subscription/individual/payment/:planType/";
export const NOUN_PRO_CONFIRMATION_PAGE =
    "/checkout/subscription/individual/confirmation/";

// NounTeam
export const NOUN_PRO_TEAM_LANDING_PAGE =
    "/pricing/icon-subscription/nounpro-team/";
export const NOUN_PRO_TEAM_CHECKOUT =
    "/checkout/subscription/team/payment/:planType/:teamName/:numSeats/:teamUser";
export const NOUN_PRO_TEAM_CONFIRMATION_PAGE =
    "/checkout/subscription/team/confirmation/";
export const NOUN_PRO_TEAM_INFO_PAGE =
    "/checkout/subscription/team/name/:planType/";

// NounPro for Education
export const NOUN_PRO_EDU_LANDING_PAGE =
    "/pricing/icon-subscription/nounpro-edu/";
export const NOUN_PRO_EDU_CHECKOUT = "/checkout/subscription/edu/payment/";
export const NOUN_PRO_EDU_CONFIRMATION_PAGE =
    "/checkout/subscription/edu/confirmation/";
export const NOUN_PRO_EDU_APPLICATION =
    "/checkout/subscription/edu/apply/form/";
export const EDU_APPLICATION_CONFIRMATION =
    "/checkout/subscription/edu/apply/confirmation/:email/";

// API routes
export const iconEditorPreviewEndpoint = ({ iconId }) =>
    `/api/private/icons/${iconId}/edit/`;

export const iconEditorTokenEndpoint = "/api/private/icons/get-key/";

/* -------------------------------------------------------------------------- */
/*                                    MENUS                                   */
/* -------------------------------------------------------------------------- */

export const authLinks = {
    login: {
        href: "/accounts/login/",
        text: "Log In"
    },
    signup: {
        href: "/accounts/signup/",
        text: "Join"
    },
    logout: {
        href: "/accounts/logout/",
        text: "Log Out"
    }
};

export const adminMenu = [
    {
        name: "Moderation",
        href: "/fort/modparty/"
    },
    {
        name: "Members",
        href: "/fort/members/"
    },
    {
        name: "Icons",
        href: "/fort/icon/"
    },
    {
        name: "Collections",
        href: "/fort/collections/"
    }
];

export const myAccountMenu = [
    {
        name: "Settings",
        href: ({ username }) => `/${username}/settings/basics/`
    },
    {
        name: "Billing Info",
        href: ({ username }) => `/${username}/settings/billing/`
    },
    {
        name: "Invoices",
        href: ({ username }) => `/${username}/settings/invoices/`
    },
    {
        name: "Prepaid Balance",
        href: prepaidBalancePath
    }
];

export const myStuffMenu = [
    {
        name: "Profile",
        href: "/dashboard/"
    },
    {
        name: "Download History",
        href: ({ username }) => `/${username}/settings/icon-history/`
    },
    {
        name: "Saved Icons",
        href: ({ username }) => `/${username}/kits/`
    }
];

export const myStuffApiMenu = [
    {
        name: "Manage API Apps",
        href: "/developers/apps/"
    },
    {
        name: "API Documentation",
        href: "http://api.thenounproject.com/",
        external: true
    }
];

const hasNotificationsText = ({ hasNotifications }) => (
    <HasNotifications hasNotifications={hasNotifications} />
);

export const creatorMenu = [
    {
        name: "Creator Dashboard",
        href: "/dashboard/"
    },
    {
        name: ({ hasNotifications }) =>
            hasNotificationsText({ hasNotifications }),
        href: ({ username }) => `/${username}/activity/`
    },
    {
        name: "Collections",
        href: ({ username }) => `/${username}/collections/`
    },
    {
        name: "Royalties",
        href: ({ username }) => `/${username}/royalties/`
    },
    {
        name: "Upload",
        href: "/upload/"
    },
    {
        name: "Creator Handbook",
        href: "/handbook/"
    }
];

export const nounProjectMenu = [
    {
        name: "About",
        href: aboutPath
    },
    {
        name: "Blog",
        href: "https://blog.thenounproject.com/",
        external: true
    },
    {
        name: "Jobs",
        href: CAREERS_PATH
    },
    {
        name: "Iconathons",
        href: "https://blog.thenounproject.com/tagged/iconathon",
        external: true
    },
    {
        name: "Submit Icons",
        href: "/creators/"
    },
    {
        name: "Submit Photos",
        href: BECOME_PHOTOGRAPHER_LANDING_PAGE
    },
    customerSupportLink,
    {
        name: "Legal",
        href: "/legal/"
    }
];

export const productMenu = [
    {
        name: "Home",
        href: homePath.url
    },
    {
        name: "Icons",
        href: ICON_LANDING_PAGE
    },
    {
        name: "Photos",
        href: photosLandingPath
    },
    {
        name: "Pricing",
        href: PRICING
    },
    {
        name: "Apps & Plugins",
        href: appsAndPluginsPath
    },
    {
        name: "API",
        href: apiMarketingPagePath
    },
    {
        name: "Lingo",
        href: lingoMarketingPagePath
    }
];

export const socialMedia = [
    {
        name: "Twitter",
        href: "http://www.twitter.com/nounproject"
    },
    {
        name: "Facebook",
        href: "http://www.facebook.com/thenounproject"
    },
    {
        name: "Instagram",
        href: "http://www.instagram.com/nounproject"
    },
    {
        name: "Dribbble",
        href: "http://www.dribbble.com/nounproject"
    },
    {
        name: "Behance",
        href: "http://www.behance.com/noun_project"
    }
];

export const footerMenu = [
    {
        name: "About Us",
        href: "/about/",
        external: false
    },
    {
        name: "Contact Us",
        href: `${contactCustomerSupportLink}?subject=Wanted to get in contact`,
        external: true
    },
    customerSupportLink,
    {
        name: "Jobs",
        href: CAREERS_PATH
    },
    {
        name: "Legal",
        href: "/legal/",
        external: false
    }
];
